<ziro-breadcrumbs>
  <ziro-breadcrumb-card-item>
    <div [innerHTML]="'tkey;menu.report.cucm_report_builder.description' | escapeHtml"></div>
  </ziro-breadcrumb-card-item>
</ziro-breadcrumbs>
<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <div class="pb-2">
    <legend>
      {{ 'tkey;reports.custom_reports.shared.header' | translate }}
    </legend>
    <ziro-cucm-report-builder-form
      [servers]="servers"
      [isNewReport]="isNewReport"
      [report]="report"
      [allReports]="allReports"
    ></ziro-cucm-report-builder-form>
  </div>
}
